export default "__VITE_PUBLIC_ASSET__d5cb264e__"